"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const translation_1 = require("../../common/js/helper/translation");
const TermsAndConditions = (props) => {
    const termsAndConditions = (0, translation_1.t)('registration.terms_conditions', { url: __APP__.AGB_URL });
    return (react_1.default.createElement("div", { className: "znd-newsletter-and-terms" },
        react_1.default.createElement("li", { key: "termsConditions", className: "znd-newsletter-and-terms__checkbox-option" },
            react_1.default.createElement("label", { className: "custom-control custom-checkbox znd-newsletter-and-terms__checkbox-label" },
                react_1.default.createElement("input", { type: "checkbox", required: true, className: "custom-control-input", checked: props.checked, onChange: props.onChange }),
                react_1.default.createElement("span", { className: "custom-control-label", dangerouslySetInnerHTML: {
                        __html: termsAndConditions,
                    } })))));
};
exports.default = (0, mobx_react_1.observer)(TermsAndConditions);
